module.exports = __webpack_public_path__ + "media/practica9.39bf5599.mp4";